<template lang="pug">
  v-container
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    DiscountDetailDialog(v-if="showDetailDiscountDialog" :show="showDetailDiscountDialog" :selectedItem="selectedItem" @close="closeDiscountDetailDialog" @fetchData="fetchSavedData")
    span.title.pa-0(ref="title") {{ $t('discountPage.pageTitle') }}
    v-row.ma-0.flex-column(v-if="discountList")
      v-list(v-if="discountList")
        v-list-item.pl-0(v-for="(item,idx) in discountList" :key="idx" @click="onDetailDiscountClick(item)" )
          v-list-item-content.title()
            v-row.ma-0.listItem
              v-col(cols="10") {{idx+1}}. {{item.title}}
              v-col.text-end(cols="2")
                v-icon fas fa-arrow-alt-right
      v-skeleton-loader(v-else type="list-item@10")



</template>

<script lang="ts">
import Vue from "vue";
import {Component, Watch} from "vue-property-decorator";
import {usePiniaStore} from "@/store/piniaStore";
import DiscountDetailDialog from "@/components/DiscountDetailDialog.vue";
import Discount from "@/model/Discount";


@Component({
  components: {
    DiscountDetailDialog
  }
})

export default class DiscountPage extends Vue {



  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private piniaStore = usePiniaStore()
  private discountList: Discount[] = []
  private fetchData: boolean = false
  private showDetailDiscountDialog: boolean = false
  private selectedItem: Discount | null = null

  @Watch('discountList')
  watchSelectedItem (newVal: Discount) {
    this.selectedItem = newVal
  }

  onDetailDiscountClick (item: Discount) {
    this.selectedItem = item
    this.showDetailDiscountDialog = true
  }

  closeDiscountDetailDialog () {
    this.showDetailDiscountDialog = false
    this.fetchSalesList()
  }

  fetchSavedData() {
    this.showDetailDiscountDialog = false
    this.snackBarColor = 'success'
    this.snackBarMessage = this.$t('discountPage.saved').toString()
    this.showSnackBar = true
    this.fetchSalesList()
  }


  async fetchSalesList(): Promise<void> {
    this.fetchData = true
    try {
      const response = await this.piniaStore.fetchDisCountList()
      this.discountList = response.data
      this.fetchData = false
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    }

  }

  mounted(): void {
    this.fetchSalesList()
  }
}
</script>

<style lang="stylus" scoped>

.listItem
  cursor pointer

</style>